module.exports = __webpack_public_path__ + "static/Juan Herrera-569aeb9d3bf66f2347e49cc4ba4506f4.jpg";